import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Input } from '../../../../../CommonComponents/OPL/Input/Input';
import { Textarea } from '../../../../../CommonComponents/OPL/Textarea/Textarea';
import { FormFieldValues } from '../../AssetBucketing.meta';

export const PageContentForm = () => {
  const {
    register,
    formState: { errors },
  } = useFormContext<FormFieldValues>();

  return (
    <Box mt="40">
      <Input
        {...register('headline')}
        label="Headline"
        type="text"
        mb="16"
        css="max-width: 300px"
        formVariant={errors?.headline ? 'error' : undefined}
        helperText={errors?.headline?.message || 'Max. 40 characters'}
        maxLength={40}
      />

      <Textarea
        {...register('supportingText')}
        maxLength={250}
        rows={4}
        label="Headline description"
        formVariant={errors?.supportingText ? 'error' : undefined}
        helperText={errors?.supportingText?.message || 'Max. 250 characters'}
      />
    </Box>
  );
};
